import React from 'react';
import { useTranslation } from 'react-i18next';

function Power({ vehicle }) {
  const { t } = useTranslation(['booking', 'common', 'search']);

  const hasAny =
    (vehicle.power && vehicle.power !== 0) ||
    vehicle.payload_capacity ||
    vehicle.volume;

  if (!hasAny) {
    return null;
  }

  return (
    <div className="section flex-row">
      {vehicle.power && vehicle.power !== 0 && (
        <div>
          <div className="title">{t('booking:power')}</div>
          <div className="section-content">{vehicle.power}</div>
        </div>
      )}

      {vehicle.payload_capacity && (
        <div>
          <div className="title">{t('booking:payload_capacity')}</div>
          <div className="section-content">{vehicle.payload_capacity}</div>
        </div>
      )}

      {vehicle.volume && (
        <div>
          <div className="title">{t('booking:volume')}</div>
          <div className="section-content">{vehicle.volume}</div>
        </div>
      )}
    </div>
  );
}

export default Power;
